// src/components/TopNavBar.js

import React, { useContext, useState, useEffect, useRef } from 'react';
import { Navbar, Nav, Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import './TopNavBar.css'; // Updated CSS (side-drawer approach)
import { LanguageContext } from '../contexts/LanguageContext';

const TopNavBar = () => {
  const { translations } = useContext(LanguageContext);

  // Track whether the mobile menu is expanded
  const [expanded, setExpanded] = useState(false);
  const navRef = useRef(null);

  // Close the mobile side-drawer if user clicks outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (expanded && navRef.current && !navRef.current.contains(event.target)) {
        setExpanded(false);
      }
    };

    if (expanded) {
      document.addEventListener('click', handleClickOutside);
    } else {
      document.removeEventListener('click', handleClickOutside);
    }
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [expanded]);

  // Collapse menu on link click
  const handleNavLinkClick = () => {
    setExpanded(false);
  };

  return (
    <>
      <Navbar
        className="custom-top-navbar"
        expand="md" // Use "md" so it collapses on screens < 768px
        onToggle={(isExpanded) => setExpanded(isExpanded)}
        expanded={expanded}
        ref={navRef}
      >
        {/* Hamburger Toggle Button (on the left in mobile) */}
        <Navbar.Toggle aria-controls="topnav-collapse" />

        {/* Collapsible / side-drawer nav links */}
        <Navbar.Collapse id="topnav-collapse">
          <Container fluid className="p-0">
            <Nav className="ms-auto">
              <Nav.Link as={Link} to="/" onClick={handleNavLinkClick}>
                {translations.home}
              </Nav.Link>
              <Nav.Link as={Link} to="/how" onClick={handleNavLinkClick}>
                {translations.how}
              </Nav.Link>
              <Nav.Link as={Link} to="/about" onClick={handleNavLinkClick}>
                {translations.about}
              </Nav.Link>
              {/* NEW: 3D Page link using translation */}
              <Nav.Link as={Link} to="/3d" onClick={handleNavLinkClick}>
                {translations.threeD}
              </Nav.Link>
            </Nav>
          </Container>
        </Navbar.Collapse>
      </Navbar>

      {/* Dimmed / blurred overlay, covering page except bottom nav bar */}
      {expanded && (
        <div
          className="navbar-overlay"
          onClick={() => setExpanded(false)}
          aria-hidden="true"
        />
      )}
    </>
  );
};

export default TopNavBar;
